import { render, staticRenderFns } from "./PartnerBoxTypes.vue?vue&type=template&id=2aeed6c4&scoped=true&"
import script from "./PartnerBoxTypes.vue?vue&type=script&lang=js&"
export * from "./PartnerBoxTypes.vue?vue&type=script&lang=js&"
import style0 from "./PartnerBoxTypes.vue?vue&type=style&index=0&id=2aeed6c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeed6c4",
  null
  
)

export default component.exports